import { FC, Fragment } from 'react';
import {
  NotificationEntries,
  NotificationsStatus,
} from 'components/Header/components/Notifications/hooks';
import { Box, Tooltip, Typography } from '@mui/material';
import { Check } from '@mui/icons-material';
import dayjs from 'dayjs';
import { t } from 'i18next';

interface NotificationItemProps {
  handleMarkNotification: ({
    id,
    variant,
  }: {
    id: string;
    variant: NotificationsStatus;
  }) => void;
  handleNotificationItemClick: ({
    id,
    variant,
    patient_id,
    task_id,
  }: {
    task_id: string;
    id: string;
    patient_id: string;
    variant: NotificationsStatus;
  }) => void;
  lastItem: boolean;
}

export const NotificationItem: FC<
  NotificationEntries & NotificationItemProps
> = ({
  lastItem,
  description,
  created_at,
  status,
  handleMarkNotification,
  id,
  patient_id,
  handleNotificationItemClick,
  task_id,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        paddingY: 1,
        gap: 2,
        cursor: 'pointer',
        borderBottom: theme =>
          lastItem ? 'none' : `1px solid ${theme.palette.grey[300]}`,
      }}
      onClick={() =>
        handleNotificationItemClick({
          patient_id: patient_id || '',
          id,
          task_id: task_id || '',
          variant: status === 'read' ? 'unread' : 'read',
        })
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='body2'>
          {description.split(':').map((item, idx) => {
            if (idx !== 0) {
              return <b key={idx}>:{item}</b>;
            }
            return <Fragment key={idx}>{item}</Fragment>;
          })}
        </Typography>
        <Typography variant='body2' sx={{ color: 'text.secondary' }}>
          {dayjs(created_at).format('MMM DD, YYYY - hh:mm A')}
        </Typography>
      </Box>
      <Box
        onClick={event => {
          event.stopPropagation();
          handleMarkNotification({
            id: id,
            variant: status === 'read' ? 'unread' : 'read',
          });
        }}
        sx={{
          cursor: 'pointer',
        }}
      >
        {status === 'unread' ? (
          <Tooltip title={t('header.notifications.popover.markAsRead')}>
            <Box
              sx={{
                marginRight: 0.5,
                height: 16,
                width: 16,
                borderRadius: '50%',
                bgcolor: theme => theme.palette.primary.main,
              }}
            />
          </Tooltip>
        ) : (
          <Tooltip title={t('header.notifications.popover.markAsUnRead')}>
            <Check color='primary' sx={{ width: 24, height: 24 }} />
          </Tooltip>
        )}
      </Box>
    </Box>
  );
};
